<template>
    <el-card>
        <el-form
            label-width="0px"
            label-position="right"
            class="w-full flex items-center">
            <el-form-item style="width: 150px;">
                <el-select
                    v-model="form.operationType"
                    :placeholder="$t('Reception.Third.type')"
                    class="w-full">
                    <el-option
                        v-for="(item, index) in option"
                        :key="index"
                        :label="item.name"
                        :value="item.code">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="width: 150px;margin: 0 10px 18px 10px;">
                <el-select
                    v-model="form.lockerType"
                    :placeholder="$t('Reception.Third.type')"
                    class="w-full">
                    <el-option
                        v-for="(item, index) in option2"
                        :key="index"
                        :label="item.name"
                        :value="item.code">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="width: 120px;">
                <el-select
                    @change="fetchArea"
                    v-model="form.storeId"
                    :placeholder="$t('Reception.Third.store')"
                    class="w-full">
                    <el-option
                        v-for="(item, index) in stores"
                        :key="`${index}-${item.id}`"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="width: 150px;margin-left: 10px;">
                <el-select
                    v-model="form.areaId"
                    :placeholder="$t('Reception.Third.area')"
                    class="w-full">
                    <el-option
                        v-for="(item, index) in areas"
                        :key="index"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <span
                style="margin: 0 10px 18px 10px;font-size: 13px;">{{ $t('Reception.Third.time') }}:
            </span>
            <el-date-picker
                style="margin-bottom: 18px;"
                v-model="date"
                type="daterange"
                :range-separator="$t('Reception.Third.zhi')"
                :start-placeholder="$t('Reception.Third.time_placeholder')"
                :end-placeholder="$t('Reception.Third.time_placeholder')"
                value-format="yyyy-MM-dd"
            />
            <el-form-item style="width:200px" label-width="10px">
                <el-button type="primary" @click="fetchData(1)">{{ $t('Common.search') }}</el-button>
                <el-button @click="resetForm">{{ $t('Common.clear') }}</el-button>
            </el-form-item>
        </el-form>
        <el-table
            v-loading="loading"
            border
            v-if="tableData"
            :data="tableData"
            class="my-4">
            <el-table-column prop="logTime" :label="$t('Common.time')" width="128px" />
            <el-table-column prop="operator" :label="$t('Reception.Third.people')" />
            <el-table-column prop="operationType" :label="$t('Reception.Third.type')" />
            <el-table-column prop="lockerType" :label="$t('Reception.Third.type3')" width="98px" />
            <el-table-column prop="storeName" :label="$t('Reception.Third.area')" />
            <el-table-column prop="areaName" :label="$t('Reception.Third.area')" />
            <el-table-column prop="lockerCode" :label="$t('Reception.Third.number')" width="95px" />
            <el-table-column prop="content" :label="$t('Reception.Third.desc')" />
        </el-table>
        <el-pagination
            v-if="tableData && tableData.length"
            class="flex justify-end"
            @current-change="fetchData"
            :current-page.sync="form.page"
            :page-size="pagination.size"
            layout="total, prev, pager, next, jumper"
            :total="pagination.total">
        </el-pagination>
    </el-card>
</template>

<script>
import {
    DatePicker,
    Table,
    TableColumn,
    Pagination,
    Tag,
    Tabs,
    Select,
    Option,
} from 'element-ui';
import timeMixin from '../../../mixins/timeMixin.js';

export default {
    name: 'save-record',
    components: {
        ElDatePicker: DatePicker,
        ElTable: Table,
        ElTableColumn: TableColumn,
        ElPagination: Pagination,
        ELSelect: Select,
        ElTag: Tag,
        ElTabs: Tabs,
        ElOption: Option,
    },
    mixins: [timeMixin],
    data() {
        return {
            // 储物柜记录
            tableData: [],
            form: {
                page: 1,
                areaId: null,
                storeId: null,
                dateFrom: null,
                dateTo: null,
                lockerType: null,  // 柜子类型(1-临时柜,2-租赁柜)
                operationType: null,  // 操作类型(1-存件开柜,2-临时取件,3-离场清柜,4-入场,5-场馆清柜,6-取件开柜,7-离场,8-场馆开锁,9-手动修改)
                page: 1,
            },
            date: null,
            pagination: {
                size: 10,
                total: 0,
            },
            loading: false,
            update: false,
            stores: [],
            option: [
                {
                    code: 4,
                    name: this.$t('Reception.Third.option4'),
                }, {
                    code: 7,
                    name: this.$t('Reception.Third.option7'),
                },
            ],
            option2: [
                {
                    code: 1,
                    name: this.$t('Reception.Third.option_type1'),
                }, {
                    code: 2,
                    name: this.$t('Reception.Third.option_type2'),
                },
            ],
            areas: [
                {
                    id: '',
                    name: this.$t('Reception.Third.area'),
                },
            ],
        };
    },
    created() {
        this.fetchData(1);
        this.fetchStore();
    },
    methods: {
        filterTime() {
            const date = new Date();
            const year = date.getFullYear();
            let month = date.getMonth() + 1;
            if (month < 10) month = `0${month}`;
            return `${year}-${month}-`;
        },
        fetchData(page = null) {
            if (page) this.form.page = page;
            if (!this.date) {
                const yearAndMonth = this.filterTime();
                const day = this.getDaysInMonth(new Date());
                let arr = [];
                arr[0] = `${yearAndMonth}01`;
                arr[1] = `${yearAndMonth}${day}`;
                this.date = arr;
            }
            const form = Object.assign({}, this.form);
            form.dateFrom = this.date[0];
            form.dateTo = this.date[1];
            this.loading = true;
            API.get('locker/log/pages', {
                params: form,
            }).then(res => {
                this.tableData = res.content;
                this.pagination.total = res.totalElements;
            }).finally(() => this.loading = false);
        },
        // 门店
        fetchStore() {
            API.get('store/list').then(res => {
                this.stores = res;
            });
        },
        fetchArea() {
            this.areas = [
                {
                    id: null,
                    name: this.$t('Reception.Third.area'),
                },
            ];
            this.form.areaId = '';
            API.get(`area?storeId=${this.form.storeId}`).then(res => {
                this.areas = this.areas.concat(res);
            });
        },
        // 清空
        resetForm() {
            this.form = {};
            this.date = null;
            this.fetchData(1);
        },
    },
};
</script>
